import { StandAlone } from "./integrations/StandAlone";

var int;

switch (process.env.INTEGRATION) {
	case 'standalone':
		int = new StandAlone();
		break;

	default:
		int = new StandAlone();
		//int = new Vanilla();
		// throw new Error(`Integration Not found: "${process.env.INTEGRATION}" must be [ruby7|greentube|standalone]`);
}

export const integration = int;